/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_EDITTEAMDATA, EDITTEAMDATA_RECEIVED } = constants.EditTeamdataConstants;

export default {
  REQUEST_EDITTEAMDATA,
  EDITTEAMDATA_RECEIVED,

  requestEditTeamData: payload => ({
    type: REQUEST_EDITTEAMDATA,
    payload
  }),
  EditTeamDataReceived: () => ({
    type: EDITTEAMDATA_RECEIVED
  })
};
